import * as S from "./style";
import homeLogo from "../../assets/img/time.png";
import React, { useCallback, useEffect, useState } from "react";
import { makeNextGameUseCase } from "../../team-game/main/helper/make-next-game-use-case";

const nextGame = makeNextGameUseCase()

interface INextMatch {
  name: string;
  logo: string;
}

function NextMatch(): React.ReactElement {
  const [nextMatch, setNextMatch] = useState<INextMatch>();

  const loadNextGame = useCallback(async () => {
    const result = await nextGame.handle({ teamId: 136 })
    setNextMatch({
      name: result.title,
      logo: result.image,
    });
  }, [])

  useEffect(() => {
    loadNextGame()
  }, [loadNextGame]);

  return (
    <S.NextMatchContainer>
      <S.NextMatchTitle>Próximo Jogo</S.NextMatchTitle>
      <S.Players>
        <S.NextMatchPlayer>
          <img src={homeLogo} alt="escudo-casa" className="home" />
          <span>Vitória</span>
        </S.NextMatchPlayer>
        <span>X</span>
        {nextMatch ? (
          <>
            <S.NextMatchPlayer>
              <img src={nextMatch.logo} alt="escudo-opposing-team" />
              <span>{nextMatch.name}</span>
            </S.NextMatchPlayer>
          </>
        ) : (
          <div>Estamos atualizando</div>
        )}
      </S.Players>
    </S.NextMatchContainer>
  );
}

export default NextMatch;